export const ROUTES = {
  BASE: {
    ENTRY: "/updates",
  },

  EXPLORE: {
    ENTRY: "/explore",
    TABLE: "/explore/table",
    VISUAL: "/explore/visual",
    COMPARE: "/explore/compare",
    SEARCH: "/explore/search",
  },
  TABLES: {
    ENTRY: "/tables",
    COUNTRIES: "/tables/Investing Country",
    INVESTORS: "/tables/Name Of Investor",
  },
};
